import { Request } from 'effect';
export const GetModularTemplate = Request.tagged('GetModularTemplate');
export const GetModularOptions = Request.tagged('GetModularOptions');
export const ListModularTemplates = Request.tagged('ListModularTemplates');
